import React, { FC } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../../ButtonComponent';
import { useParams } from 'react-router-dom';
import { useDisputesContext } from '../../../store/disputes/disputes-context';
import { archivatingDispute } from '../../../store/disputes/actions/disputes';

interface Props {
	closeModal: () => void;
	onSuccess: () => void;
	onError: () => void;
}

export const ArchiveDisputeModal: FC<Props> = (props) => {
	const { closeModal, onSuccess, onError } = props;
	const { disputeQueueItemId } = useParams<{ disputeQueueItemId: string }>();
	const { disputesContextState: { isArchivatingDisputeLoading }, dispatch } = useDisputesContext();

	return (
		<>
			<div className="text-center fs-6">Are you sure you want to archive?</div>

			<div className="text-center mt-10 mb-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Archive"
					additionalClass="btn-sm ms-10 w-100px"
					onButtonClick={(): Promise<void> => archivatingDispute(dispatch, disputeQueueItemId, onSuccess, onError)}
					loading={isArchivatingDisputeLoading}
					isDisabled={isArchivatingDisputeLoading}
				/>
			</div>
		</>
	);
};
